import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export const SavedItemsList = universal(
    universalImport({
        chunkName: () => 'SavedItemsLazy',
        path: () => path.join(__dirname, '../../../../components/SavedItemsList/SavedItemsList'),
        resolve: () => require.resolveWeak('../../../../components/SavedItemsList/SavedItemsList'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "SavedItemsLazy" */ '../../../../components/SavedItemsList/SavedItemsList'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);
